/*
 * MIT License
 *
 * Copyright (c) 2022 яαvoroηα
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the
 * Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
 * AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH
 * THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



import '@styles/main.scss'
import Common from "@scripts/common";
import Guide from '@scripts/guide'
import Missions from "@scripts/blocks/missions";
import Partenaires from "@scripts/blocks/partenaires";
import Gallery from "@scripts/blocks/la-vie-a-bord";
import Blog from "@scripts/blog/blog";
import Events from "@scripts/events";
import Newsletter from "@scripts/blocks/newsletter";

const { DEV } = import.meta.env
const Mission = new Missions()
const Partenaire = new Partenaires()
const LaVieABord = new Gallery()
const BlogContainer = new Blog();
const events = new Events();
const common = new Common();
const newsletter = new Newsletter();

/**
 * Enable guide in dev mode
 */
DEV && new Guide().start()
